var count = 0;
// Cart Drawer + Cart page
document.addEventListener("DOMContentLoaded", e => {
  if (location.pathname.includes("/cart")) {
    document.body.classList.add("bss-price-hiding");
  }
});

  /*
  ============================================================================
  PUR HAIR PRO – Hide only the BSS quantity table

  Purpose:
  - Hides the BSS quantity-pricing table inside the cart.
  - Keeps the mobile product price and “Sie sparen” badge visible.
  - Does not hide the complete mobile price wrapper.
  ============================================================================
  */

const style1 = document.createElement("style");

style1.textContent = `
    
  .cart-item__price-wrapper .bss-b2b-qb-table,
  .cart-item__price-wrapper .bss-b2b-cart-item-qty-table,
  .main-cart__items-wrapper:has([bss-b2b-item-original-price]) [x-show="isLoading"],
  .main-cart__items-wrapper:has([bss-b2b-item-original-price]) [id^="CartItem__Loading"],
  .cart-drawer__items__wrapper:has([bss-b2b-item-original-price]) [x-show="isLoading"],
  .cart-drawer__items__wrapper:has([bss-b2b-item-original-price]) [id^="CartItem__Loading"] {
    display: none !important;
  }

  [bss-b2b-item-original-price] > span:first-child {
    margin-right: 0 !important;
  }

  [name="checkout"] {
    pointer-events: unset !important;
  }
`;

document.head.appendChild(style1);
/*
  ============================================================================
  End of Hide only the BSS quantity table
  ============================================================================
  */

(() => {

  const theme = Shopify.theme.schema_name;
  if (theme !== 'Maximize') return;

  
/*
==============================================================================
PUR HAIR PRO – Instant Predictive-Search Price Display

File: bss-custom.js
Author: Gino Cometti
Date: 23.09.2026
Version: 2.1

Purpose:
- Shows completed BSS prices immediately in predictive search.
- Continues working when the customer changes the search term.
- Reconnects automatically when Shopify replaces the search results.
- Supports desktop and mobile search results.
- Protects prices from unapproved customers.
==============================================================================
*/

(function () {
  const searchResultObservers = new Map();
  let searchContainerObserver = null;

  /*
   * Confirm that the customer is approved to see B2B prices.
   */
  function customerIsApproved() {
    const customerDataElement = document.querySelector(
      "#bss-lock-store-data"
    );

    if (!customerDataElement) {
      return false;
    }

    try {
      const storeData = JSON.parse(
        customerDataElement.textContent || "{}"
      );

      return (
        Array.isArray(storeData.customer?.tags) &&
        storeData.customer.tags.includes("Freigeschaltet")
      );
    } catch (error) {
      console.warn(
        "PUR HAIR PRO: Customer approval information could not be read.",
        error
      );

      return false;
    }
  }

  /*
   * Show a price as soon as its value exists.
   */
  function revealPredictiveSearchPrices(searchResults) {
    searchResults
      .querySelectorAll("[bss-b2b-product-price]")
      .forEach((priceElement) => {
        const priceText = priceElement.textContent.trim();

        /*
         * Never reveal an empty price element.
         */
        if (!priceText) {
          return;
        }

        /*
         * Avoid repeatedly applying the same style.
         */
        if (
          priceElement.style.getPropertyValue("visibility") ===
            "visible" &&
          priceElement.style.getPropertyPriority("visibility") ===
            "important"
        ) {
          return;
        }

        priceElement.style.setProperty(
          "visibility",
          "visible",
          "important"
        );
      });
  }

  /*
   * Connect to every currently available predictive-search container.
   *
   * Shopify can completely replace this container whenever the
   * search term changes. Detached observers are therefore removed,
   * and observers are added to newly created containers.
   */
  function connectPredictiveSearchObservers() {
    searchResultObservers.forEach((observer, searchResults) => {
      if (!searchResults.isConnected) {
        observer.disconnect();
        searchResultObservers.delete(searchResults);
      }
    });

    document
      .querySelectorAll("#predictive-search-results")
      .forEach((searchResults) => {
        revealPredictiveSearchPrices(searchResults);

        /*
         * Do not attach a second observer to the same container.
         */
        if (searchResultObservers.has(searchResults)) {
          return;
        }

        const resultsObserver = new MutationObserver(() => {
          revealPredictiveSearchPrices(searchResults);
        });

        resultsObserver.observe(searchResults, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ["style", "class"]
        });

        searchResultObservers.set(
          searchResults,
          resultsObserver
        );
      });
  }

  /*
   * Check whether a mutation inserted or removed a complete
   * predictive-search results container.
   */
  function mutationContainsSearchContainer(mutation) {
    const changedNodes = [
      ...mutation.addedNodes,
      ...mutation.removedNodes
    ];

    return changedNodes.some((node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
      }

      return (
        node.matches?.("#predictive-search-results") ||
        node.querySelector?.("#predictive-search-results")
      );
    });
  }

  function initializeInstantPredictiveSearchPrices() {
    if (!customerIsApproved()) {
      return;
    }

    /*
     * Process any search results already on the page.
     */
    connectPredictiveSearchObservers();

    /*
     * Keep watching because Shopify replaces the entire search-results
     * container whenever another search term is entered.
     */
    searchContainerObserver = new MutationObserver((mutations) => {
      if (mutations.some(mutationContainsSearchContainer)) {
        connectPredictiveSearchObservers();
      }
    });

    searchContainerObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /*
   * Disconnect everything when the visitor leaves the page.
   */
  window.addEventListener(
    "pagehide",
    () => {
      searchContainerObserver?.disconnect();

      searchResultObservers.forEach((observer) => {
        observer.disconnect();
      });

      searchResultObservers.clear();
    },
    { once: true }
  );

  /*
   * Support scripts loaded before or after DOMContentLoaded.
   */
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeInstantPredictiveSearchPrices,
      { once: true }
    );
  } else {
    initializeInstantPredictiveSearchPrices();
  }
})();

/*
==============================================================================
End of PUR HAIR PRO – Instant Predictive-Search Price Display
==============================================================================
*/

/*
==============================================================================
PUR HAIR PRO – Instant minicart cross-selling prices

File: bss-custom.js
Author: Gino Cometti
Date: 23.09.2026
Version: 1.0

Purpose:
- Immediately reveals completed prices in the minicart cross-selling section.
- Targets only “Das fehlt noch in deinem Salon”.
- Responds when the minicart content is rebuilt.
- Runs only for customers with the "Freigeschaltet" tag.
==============================================================================
*/

(function () {
  let cartDrawerObserver = null;
  let cartDrawerContainerObserver = null;

  /*
   * Confirm that the current customer is approved.
   */
  function cartDrawerCustomerIsApproved() {
    const customerDataElement = document.querySelector(
      "#bss-lock-store-data"
    );

    if (!customerDataElement) {
      return false;
    }

    try {
      const storeData = JSON.parse(
        customerDataElement.textContent || "{}"
      );

      return (
        Array.isArray(storeData.customer?.tags) &&
        storeData.customer.tags.includes("Freigeschaltet")
      );
    } catch (error) {
      console.warn(
        "PUR HAIR PRO: Minicart customer information could not be read.",
        error
      );

      return false;
    }
  }

  /*
   * Reveal completed cross-selling prices.
   */
  function revealCartDrawerUpsellPrices() {
    document
      .querySelectorAll(
        "#CartDrawer__Upsell [bss-b2b-product-price]"
      )
      .forEach((priceElement) => {
        const priceText = priceElement.textContent.trim();

        /*
         * Never reveal an empty price element.
         */
        if (!priceText) {
          return;
        }

        /*
         * Avoid unnecessary repeated style changes.
         */
        if (
          priceElement.style.getPropertyValue("visibility") ===
            "visible" &&
          priceElement.style.getPropertyPriority("visibility") ===
            "important"
        ) {
          return;
        }

        priceElement.style.setProperty(
          "visibility",
          "visible",
          "important"
        );
      });
  }

  /*
   * Connect to the minicart and watch for updated content.
   */
  function connectCartDrawerUpsellObserver() {
    const cartDrawer = document.querySelector(
      "#CartDrawer__Container"
    );

    if (!cartDrawer) {
      return false;
    }

    revealCartDrawerUpsellPrices();

    cartDrawerObserver = new MutationObserver(() => {
      revealCartDrawerUpsellPrices();
    });

    cartDrawerObserver.observe(cartDrawer, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["style"]
    });

    return true;
  }

  function initializeInstantCartDrawerUpsellPrices() {
    /*
     * Protect prices from unapproved and logged-out visitors.
     */
    if (!cartDrawerCustomerIsApproved()) {
      return;
    }

    if (connectCartDrawerUpsellObserver()) {
      return;
    }

    /*
     * Wait until Shopify creates the minicart container.
     */
    cartDrawerContainerObserver = new MutationObserver(() => {
      if (connectCartDrawerUpsellObserver()) {
        cartDrawerContainerObserver.disconnect();
        cartDrawerContainerObserver = null;
      }
    });

    cartDrawerContainerObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /*
   * Disconnect observers when the visitor leaves the page.
   */
  window.addEventListener(
    "pagehide",
    () => {
      cartDrawerObserver?.disconnect();
      cartDrawerContainerObserver?.disconnect();
    },
    { once: true }
  );

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeInstantCartDrawerUpsellPrices,
      { once: true }
    );
  } else {
    initializeInstantCartDrawerUpsellPrices();
  }
})();

/*
==============================================================================
End of PUR HAIR PRO – Instant minicart cross-selling prices
==============================================================================
*/

/*
==============================================================================
PUR HAIR PRO – Instant Cart-Page Recommendation Prices

File: bss-custom.js
Author: Gino Cometti
Date: 24.09.2026
Version: 1.0

Purpose:
- Shows completed prices under “Das fehlt noch in deinem Salon”.
- Restores prices immediately after a cart quantity update.
- Continues working when Shopify rebuilds the cart page.
- Does not calculate or modify prices.
- Runs only for approved B2B customers.
==============================================================================
*/

(function () {
  const observerRoot = document.querySelector("#MainContent");

  if (!observerRoot) {
    return;
  }

  /*
   * Confirm that the customer may see B2B prices.
   */
  function mainCartCustomerIsApproved() {
    const customerDataElement = document.querySelector(
      "#bss-lock-store-data"
    );

    if (!customerDataElement) {
      return false;
    }

    try {
      const storeData = JSON.parse(
        customerDataElement.textContent || "{}"
      );

      return (
        Array.isArray(storeData.customer?.tags) &&
        storeData.customer.tags.includes("Freigeschaltet")
      );
    } catch (error) {
      console.warn(
        "PUR HAIR PRO: Cart-page customer information could not be read.",
        error
      );

      return false;
    }
  }

  if (!mainCartCustomerIsApproved()) {
    return;
  }

  /*
   * Reveal prices only when a completed price value exists.
   */
  function revealMainCartUpsellPrices() {
    document
      .querySelectorAll(
        "#MainCartUpsell [bss-b2b-product-price]"
      )
      .forEach((priceElement) => {
        if (!priceElement.textContent.trim()) {
          return;
        }

        if (
          priceElement.style.getPropertyValue("visibility") ===
            "visible" &&
          priceElement.style.getPropertyPriority("visibility") ===
            "important"
        ) {
          return;
        }

        priceElement.style.setProperty(
          "visibility",
          "visible",
          "important"
        );
      });
  }

  let refreshScheduled = false;

  /*
   * Combine multiple cart mutations into one visual update.
   */
  function scheduleMainCartUpsellRefresh() {
    if (refreshScheduled) {
      return;
    }

    refreshScheduled = true;

    requestAnimationFrame(() => {
      refreshScheduled = false;
      revealMainCartUpsellPrices();
    });
  }

  const mainCartObserver = new MutationObserver(
    scheduleMainCartUpsellRefresh
  );

  mainCartObserver.observe(observerRoot, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ["style"]
  });

  /*
   * Process prices already on the page.
   */
  revealMainCartUpsellPrices();

  window.addEventListener(
    "pagehide",
    () => mainCartObserver.disconnect(),
    { once: true }
  );
})();

/*
==============================================================================
End of PUR HAIR PRO – Instant Cart-Page Recommendation Prices
==============================================================================
*/

  const style = document.createElement("style");
  style.textContent = `
        body.bss-price-hiding .cart-item__price-wrapper,body.bss-price-hiding .cart-item__price-wrapper *,
        body.bss-price-hiding .cart-drawer-item__price__wrapper, body.bss-price-hiding .cart-drawer-item__price__wrapper *,
        body.bss-price-hiding .cart-drawer__total p:nth-child(2),body.bss-price-hiding .cart-drawer__total p:nth-child(2) *,
        body.bss-price-hiding .cart-item__final-price, body.bss-price-hiding .cart-item__final-price *, 
        body.bss-price-hiding .cart-item__final-line-price,
        body.bss-price-hiding .main-cart__total-price {
            // visibility: hidden !important;
        }
    `;
  document.head.appendChild(style);

  document.addEventListener("click", e => {
    if (e.target.closest(".cart-item__quantity-button, .cart-item__remove, .cart-item__quantity [aria-label='Minus'], .cart-item__quantity [aria-label='Plus']")) {
      count = -1;
      document.body.classList.add("bss-price-hiding");
    }
  });

  document.addEventListener("change", e => {
    if (e.target.matches(".cart-qty, .cart-item__quantity-input")) {
      count = -1;
      document.body.classList.add("bss-price-hiding");
    }
  });

  // window.bssB2BHooks.actions["custom:cart/showSubtotalPrice"] = () => {
  //   ++count;
  //   if (isOdd(count)) {
  //     document.body.classList.remove("bss-price-hiding");
  //   }
  // }

  // function isOdd(number) {
  //   return number > 0 && number % 2 === 1;
  // }
/*
==============================================================================
This section is to comment out the Minicart/Cart drawer and the cart page.
Author: Gino Cometti
Date: 21.09.2026
Sinnce it appears two times, I have commented out this one.
==============================================================================


  BSS_B2B.addAction("custom:qbCart/showPrice", ({ originalPriceElements, finalLinePriceElements, cartItem, force }) => {
    if (BSS_B2B.isModifiedPrice) {
      const savePrice = cartItem.price - cartItem.bssB2BPriceAfterQB;
      originalPriceElements.forEach(originalPriceElement => {
        originalPriceElement.insertAdjacentHTML("beforeEnd", `<div style="flex-basis: 100%;"> <span style="color: #fff; background: #7d9537; border-radius: 4px; padding: 2px 8px; font-size: 11px; font-weight: 500;">
          Sie sparen ${BSS_B2B.formatMoney(savePrice)}
          </span> 
          </div>`)
      });
    }
  })
*/
  window.addEventListener('bss_b2b:loadedObserver', () => {
    if (BSS_B2B.td.status && Shopify.locale === 'en' && BSS_B2B.td.tdTranslations.excluded_vat_text === 'exc. VAT | ') {
      BSS_B2B.td.tdTranslations.excluded_vat_text = 'exc. VAT';
    }
  }, { once: true });

  const styleEl = document.createElement('style');
  styleEl.id = 'bss-b2b-style';
  styleEl.textContent = `

        #CartDrawer__Upsell__Wrapper .price__container.price .price-wrapper span {
            font-size: 13px !important;
            line-height: 1.3 !important;
        }

        .bss-b2b-cart-item-qty-table .bss-b2b-price-has-vat {
            display: none;
        }

        [bss-b2b-variant-price] > span:not(.main-price) {
            font-size: calc(var(--heading-base-size) * var(--heading-font-scale) * 0.85 * 1.0) !important;
            font-weight: var(--heading-font-weight);
            font-family: var(--heading-font-family);
        }

        .account__menu-bar-content > li:first-child {
            display: none !important;
        }

        #bss-b2b-register-form > div:first-child:has(> h6) {
            margin-bottom: 12px;
            margin-top: -24px;
        }
    `;
  document.head.appendChild(styleEl);
})();

/*
==============================================================================
PUR HAIR PRO – BSS recommended-product price refresh

File: assets/bss-custom.js
Author: Gino Cometti
Created: 21.09.2026
Comments cleaned: 22.09.2026
Version: 1.1

Purpose:
- Loads BSS product prices when the page first opens.
- Refreshes recommendation prices after the cart changes.
- Prevents duplicate recommendation prices from remaining hidden.
- Queues another refresh if BSS is already processing prices.
- Observes changes to the cart icon and cart quantity.

Scope:
- This version only handles the existing BSS loading and duplicate-price logic.
- It does not add a separate MainCartUpsell price-reveal function.
- It does not add a separate observer for the full cart recommendation section.
- It does not calculate or modify product prices.
==============================================================================
*/

let isB2BPriceProcessing = false;
let repeatB2BPriceProcessing = false;

/*
==============================================================================
1. Load BSS product data

If a second cart update occurs while BSS is still processing, the second
request is remembered and executed after the current process finishes.
==============================================================================
*/

async function handleCartDrawerFooterMutation() {
  /*
   * Do not begin another BSS process while one is already running.
   * Remember that another refresh is required instead.
   */
  if (isB2BPriceProcessing) {
    repeatB2BPriceProcessing = true;
    return;
  }

  isB2BPriceProcessing = true;

  try {
    do {
      repeatB2BPriceProcessing = false;

      const bss = window.BSS_B2B;
      const productStorage =
        bss?.storage?.productStorage;
      const productSubject =
        bss?.observer?.productSubject;

      /*
       * BSS may not yet be ready when the page initially loads.
       * The bss_b2b:loadedObserver event below will try again later.
       */
      if (!productStorage || !productSubject) {
        break;
      }

      const result = await productStorage.load();

      /*
       * Notify BSS when new product or variant information is found.
       * This allows BSS to process prices in recommendation sections.
       */
      if (
        result &&
        (
          result.notExistProductIds?.length ||
          result.productIds?.length ||
          result.variantIds?.size
        )
      ) {
        productSubject.notifyObserver(
          "LazyProduct",
          "LoadedLazyProduct",
          { ...result }
        );
      }
    } while (repeatB2BPriceProcessing);
  } catch (error) {
    console.warn(
      "PUR HAIR PRO: BSS recommended-product price refresh failed.",
      error
    );
  } finally {
    isB2BPriceProcessing = false;
  }
}

/*
==============================================================================
2. Repair duplicate BSS product-price elements

The same product can appear more than once on a page—for example:
- In the normal product recommendations.
- In the cart-drawer recommendations.

BSS may process one occurrence and leave another occurrence hidden.

This function finds a successfully processed price and copies its HTML into
hidden occurrences of the same product variant.
==============================================================================
*/

function revealDuplicateBssProductPrices() {
  const priceElements = [
    ...document.querySelectorAll(
      "[bss-b2b-product-price]"
    )
  ];

  const processedPrices = new Map();

  /*
   * Collect prices that BSS has already processed successfully.
   */
  priceElements.forEach((priceElement) => {
    const productId =
      priceElement.getAttribute(
        "bss-b2b-product-id"
      ) || "";

    const variantId =
      priceElement.getAttribute(
        "bss-b2b-variant-id"
      ) || "";

    const priceKey = `${productId}:${variantId}`;

    if (
      priceElement.style.visibility === "visible"
    ) {
      processedPrices.set(
        priceKey,
        priceElement.innerHTML
      );
    }
  });

  /*
   * Copy the processed price into hidden occurrences
   * of the identical product variant.
   */
  priceElements.forEach((priceElement) => {
    const productId =
      priceElement.getAttribute(
        "bss-b2b-product-id"
      ) || "";

    const variantId =
      priceElement.getAttribute(
        "bss-b2b-variant-id"
      ) || "";

    const priceKey = `${productId}:${variantId}`;
    const processedPriceHtml =
      processedPrices.get(priceKey);

    if (
      processedPriceHtml &&
      priceElement.style.visibility !== "visible"
    ) {
      priceElement.innerHTML =
        processedPriceHtml;

      priceElement.style.setProperty(
        "visibility",
        "visible",
        "important"
      );
    }
  });
}

/*
==============================================================================
3. Refresh BSS and repair duplicate prices

The duplicate-price repair runs:
- During the browser's next visual rendering frame.
- Again after 150 milliseconds for elements rendered slightly later.
==============================================================================
*/

async function refreshBssProductPrices() {
  await handleCartDrawerFooterMutation();

  requestAnimationFrame(
    revealDuplicateBssProductPrices
  );

  window.setTimeout(
    revealDuplicateBssProductPrices,
    150
  );
}

/*
==============================================================================
4. Initialize the cart observer

The cart-count element changes when products or quantities change.

The parent element is observed so the observer can continue working if
Shopify replaces the cart-count element itself.
==============================================================================
*/

function initializeBssProductPriceRefresh() {
  /*
   * Process prices immediately when initialization begins.
   */
  refreshBssProductPrices();

  const cartIcon =
    document.querySelector("#cart-icon-bubble");

  /*
   * Stop here if this page does not contain a cart icon.
   */
  if (!cartIcon) {
    return;
  }

  const observerRoot =
    cartIcon.parentElement || cartIcon;

  const cartObserver =
    new MutationObserver(() => {
      refreshBssProductPrices();
    });

  cartObserver.observe(observerRoot, {
    childList: true,
    subtree: true,
    characterData: true
  });

  /*
   * Disconnect the observer when the visitor leaves the page.
   * This prevents an unused observer from remaining in memory.
   */
  window.addEventListener(
    "pagehide",
    () => cartObserver.disconnect(),
    { once: true }
  );
}

/*
==============================================================================
5. Run again when the BSS engine becomes ready
==============================================================================
*/

window.addEventListener(
  "bss_b2b:loadedObserver",
  refreshBssProductPrices
);

/*
==============================================================================
6. Support scripts loaded before or after DOMContentLoaded
==============================================================================
*/

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    initializeBssProductPriceRefresh,
    { once: true }
  );
} else {
  initializeBssProductPriceRefresh();
}

/*
==============================================================================
End of PUR HAIR PRO – BSS recommended-product price refresh
==============================================================================
*/

// start 3e2e97c9-bc25-44c4-bf08-82f196d40ce6
(() => {
  try {
    const calculateQbDiscountedPrice = (originalPrice, discountType, discountValue) => {
      const rateMarket = Number(window.Shopify.currency.rate) || 1;
      const priceInStoreCurrency = originalPrice / rateMarket;
      let discountAmount = 0;
      let discountedPrice = originalPrice;
      if (discountType === 0) {
        const targetPrice = discountValue * 100;
        if (targetPrice < priceInStoreCurrency) {
          discountAmount = parseFloat(((priceInStoreCurrency - targetPrice) / 100).toFixed(2));
          discountAmount = parseFloat((discountAmount * rateMarket).toFixed(2)) * 100;
          discountedPrice = Math.round((originalPrice - discountAmount) * 100) / 100;
        }
      } else if (discountType === 1) {
        discountAmount = discountValue * rateMarket * 100;
        discountedPrice = originalPrice > discountAmount ? originalPrice - discountAmount : 0;
      } else if (discountType === 2) {
        discountAmount = parseFloat(((priceInStoreCurrency * discountValue) / 100).toFixed(2));
        discountAmount = parseFloat((discountAmount * rateMarket).toFixed(2));
        discountedPrice = originalPrice - discountAmount;
      }
      return discountedPrice;
    };

    const findMatchingQbTier = (qbRule, quantity) => {
      if (!qbRule || qbRule.rule_setting !== 0) return null;
      let matchedTier = null;
      (qbRule.qty_table || []).forEach((tierRow) => {
        const qtyFrom = parseInt(tierRow.qty_from);
        const qtyTo = tierRow.qty_to;
        const isInRange = qtyTo != null && String(qtyTo).length > 0
          ? quantity >= qtyFrom && quantity <= parseInt(qtyTo)
          : quantity >= qtyFrom;
        if (isInRange) matchedTier = tierRow;
      });
      return matchedTier;
    };

    const formatPriceRespectingTaxDisplay = (variantStorage, grossPriceCents) => {
      const b2b = window.BSS_B2B;
      if (!variantStorage.appliedTD) return b2b.formatMoney(grossPriceCents);
      const taxRate = b2b.countryTax || 0;
      const taxesIncluded = !!b2b.shopData?.taxes_included;
      const isTaxable = !!variantStorage.taxable;
      const priceForTaxDisplay = {
        priceNoVat: isTaxable && taxesIncluded ? grossPriceCents / (1 + taxRate) : grossPriceCents,
        priceHasVat: isTaxable && !taxesIncluded ? grossPriceCents * (1 + taxRate) : grossPriceCents,
        comparePriceNoVat: null,
        comparePriceHasVat: null,
      };
      const priceHtml = b2b.td.utils.product.getPriceHtml(variantStorage.appliedTD, priceForTaxDisplay, 1);
      return (priceHtml.priceNoVat || "") + (priceHtml.priceHasVat || "");
    };

    const findAppliedQbRuleForVariant = (variantId, productId) => {
      const appliedRulesMap = window.BSS_B2B.qb?.utils?.product?.appliedQbRules;
      if (!(appliedRulesMap instanceof Map)) return null;
      for (const rulesForForm of appliedRulesMap.values()) {
        const rulesArray = Array.isArray(rulesForForm) ? rulesForForm : [rulesForForm];
        const matched = rulesArray.find(
          (rule) => rule?.appliedVariantId === variantId || rule?.appliedProductId === productId
        );
        if (matched) return matched;
      }
      return null;
    };

    const renderDualPriceOnProductForm = (productFormRoot) => {
      if (!productFormRoot) return;
      const priceElement = productFormRoot.querySelector("[bss-b2b-variant-price]");
      if (!priceElement) return;
      const variantId = parseInt(priceElement.getAttribute("bss-b2b-variant-id"));
      const productId = parseInt(priceElement.getAttribute("bss-b2b-product-id"));
      if (!variantId || !window.BSS_B2B?.qb?.status) return;
      const variantStorage = window.BSS_B2B.storage.variantStorage.get(variantId);
      if (!variantStorage) return;
      let originalPrice = window.BSS_B2B.utils.getModifyPrice(variantStorage, "qb");
      if (!originalPrice) originalPrice = variantStorage.price;
      if (!originalPrice) return;
      const appliedQbRule = findAppliedQbRuleForVariant(variantId, productId);
      const quantityInput = productFormRoot.querySelector('input[name="quantity"]');
      const currentQuantity = parseInt(quantityInput?.value) || 1;
      const matchedTier = appliedQbRule ? findMatchingQbTier(appliedQbRule, currentQuantity) : null;
      if (!matchedTier) {
        priceElement.innerHTML = formatPriceRespectingTaxDisplay(variantStorage, originalPrice);
        return;
      }
      const discountedPrice = calculateQbDiscountedPrice(
        originalPrice,
        parseInt(matchedTier.discount_type),
        parseFloat(matchedTier.discount_value)
      );
      if (discountedPrice < originalPrice) {
        priceElement.innerHTML =
          `<s style="opacity:0.55;margin-right:6px;font-size:0.85em;">${formatPriceRespectingTaxDisplay(variantStorage, originalPrice)}</s>` +
          formatPriceRespectingTaxDisplay(variantStorage, discountedPrice);
      } else {
        priceElement.innerHTML = formatPriceRespectingTaxDisplay(variantStorage, originalPrice);
      }
    };

    const refreshAllProductFormPrices = () => {
      document.querySelectorAll("[bss-b2b-product-form]").forEach((formEl) => {
        renderDualPriceOnProductForm(formEl.closest("form") || formEl);
      });
    };

    document.addEventListener("input", (event) => {
      if (event.target.matches && event.target.matches('input[name="quantity"]')) {
        const productFormRoot = event.target.closest("[bss-b2b-product-form]") || event.target.closest("form");
        renderDualPriceOnProductForm(productFormRoot);
      }
    });

    document.addEventListener("click", (event) => {
      if (event.target.closest && event.target.closest('[name="plus"], [name="minus"]')) {
        setTimeout(refreshAllProductFormPrices, 60);
      }
    });

    refreshAllProductFormPrices();

    const CART_PRICE_SELECTOR_ORIGIN = '[bss-b2b-item-original-price], .cart-item__price, .cart-drawer-item__price__wrapper';
    const CART_PRICE_SELECTOR_FINAL_LINE = '[bss-b2b-final-line-price], .cart-item__final-line-price';
    const CART_PRICE_SELECTOR_TOTAL = '[bss-b2b-cart-total-price], .main-cart__total-price, .cart-drawer__total p:nth-child(2)';
    const CART_QTY_INPUT_SELECTOR = '.cart-item__quantity-input, .cart-qty, input[name="quantity"]';
    const CART_LINES_REFRESH_RETRY_DELAYS_MS = [1200, 2500, 3500];
    const CART_LINES_REFRESH_FALLBACK_INTERVAL_MS = 3000;
    /* const MIN_PRICE_LOADING_DURATION_MS = 350; */
    /*
    PUR HAIR PRO
    No artificial display delay during cart price updates.
    */
    const MIN_PRICE_LOADING_DURATION_MS = 0;
    /* The above code is a replacement of: const MIN_PRICE_LOADING_DURATION_MS = 350; */


    /*
      ==============================================================================
      PUR HAIR PRO – Global cart price hiding disabled

      Purpose:
      BSS previously hid every cart price while one product was recalculated.
      The synchronization system remains active, but existing prices stay visible.
      ==============================================================================
      const CART_PRICE_HIDING_STYLE_ELEMENT_ID = "bss-b2b-cart-price-hiding-style";
      if (!document.getElementById(CART_PRICE_HIDING_STYLE_ELEMENT_ID)) {
        const cartPriceHidingStyleElement = document.createElement("style");
        cartPriceHidingStyleElement.id = CART_PRICE_HIDING_STYLE_ELEMENT_ID;
        cartPriceHidingStyleElement.textContent =
          "body.bss-price-hiding [bss-b2b-item-original-price], " +
          "body.bss-price-hiding .cart-item__price, " +
          "body.bss-price-hiding .cart-drawer-item__price__wrapper, " +
          "body.bss-price-hiding [bss-b2b-final-line-price], " +
          "body.bss-price-hiding .cart-item__final-line-price, " +
          "body.bss-price-hiding [bss-b2b-cart-total-price], " +
          "body.bss-price-hiding .main-cart__total-price, " +
          "body.bss-price-hiding .cart-drawer__total p:nth-child(2) " +
          "{ visibility: hidden !important; }";
        document.head.appendChild(cartPriceHidingStyleElement);
      }
    */

    /* 
     ==============================================================================
     Created by: Gino Cometti
      Date: 21.09.2026
     The code below is will be replaced by the following code under it.
     ==============================================================================
    
    const setPriceElementLoading = (priceElement) => {
      if (!priceElement) return;
      priceElement.style.setProperty("visibility", "hidden", "important");
      forceElementRepaint(priceElement);
    };
    */

    /*
    ==============================================================================
    PUR HAIR PRO – Keep cart prices visible during recalculation

    Purpose:
    The last displayed price remains visible until BSS has calculated and rendered
    the replacement price. This prevents blinking and empty price areas.
    ==============================================================================
    */
    const setPriceElementLoading = () => {
      // Intentionally empty.
      // BSS synchronization continues without hiding the displayed prices.
    };
    /*
    ==============================================================================
     End of PUR HAIR PRO – Keep cart prices visible during recalculation
     ==============================================================================
    */

    const forceElementRepaint = (priceElement) => {
      const previousTransform = priceElement.style.transform;
      priceElement.style.transform = previousTransform ? previousTransform + " translateZ(0)" : "translateZ(0)";
      void priceElement.getBoundingClientRect();
      priceElement.style.transform = previousTransform;
    };

    const setPriceElementReady = (priceElement, html) => {
      if (!priceElement) return;
      const isAlreadyCorrect = priceElement.innerHTML === html && priceElement.style.visibility === "visible";
      if (isAlreadyCorrect) return;
      priceElement.innerHTML = html;
      priceElement.setAttribute("data-bss-optimistic", "1");
      priceElement.style.setProperty("visibility", "visible", "important");
      forceElementRepaint(priceElement);
    };

    const readCartRowQuantity = (cartRowEl, overrideQuantity) => {
      if (overrideQuantity != null) return overrideQuantity;
      const qtyInput = cartRowEl.querySelector(CART_QTY_INPUT_SELECTOR);
      return parseInt(qtyInput?.value) || 1;
    };

    const computeCartLineQbPricing = (cartRowEl, overrideQuantity) => {
      const lineKey = cartRowEl.getAttribute("data-cart-item-key");
      if (!lineKey) return null;
      const variantId = parseInt(lineKey.split(":")[0]);
      const b2b = window.BSS_B2B;
      if (!b2b?.storage?.variantStorage) return null;
      const variantStorage = b2b.storage.variantStorage.get(variantId);
      if (!variantStorage) return null;
      let unitPrice = b2b.utils.getModifyPrice(variantStorage, "qb");
      if (!unitPrice) unitPrice = variantStorage.price;
      if (!unitPrice) return null;
      const quantity = readCartRowQuantity(cartRowEl, overrideQuantity);
      const appliedRulesMap = b2b.qb?.utils?.cart?.appliedRules;
      const matchedRule = appliedRulesMap instanceof Map ? appliedRulesMap.get(lineKey) : null;
      const matchedTier = matchedRule ? findMatchingQbTier(matchedRule, quantity) : null;
      const discountedUnitPrice = matchedTier
        ? calculateQbDiscountedPrice(unitPrice, parseInt(matchedTier.discount_type), parseFloat(matchedTier.discount_value))
        : unitPrice;
      return { variantStorage, unitPrice, quantity, discountedUnitPrice };
    };

    const buildOriginPriceHtml = (variantStorage, unitPrice, discountedUnitPrice, quantity) => {
      const priceHtml = formatPriceRespectingTaxDisplay(variantStorage, discountedUnitPrice);
      if (!priceHtml) return null;
      if (!(discountedUnitPrice < unitPrice)) return `<span class="bss-b2b-qb-price">${priceHtml}</span>`;
      /*
      const savedAmount = Math.round((unitPrice - discountedUnitPrice) * 100) / 100;
      */
     /*
      ==============================================================================
      PUR HAIR PRO
      Calculate the total saving for the complete quantity,
      not only the saving for one unit.
      ==============================================================================
      */
      const savedAmount =
        Math.round(
          (unitPrice - discountedUnitPrice) *
          quantity *
          100
        ) / 100;
      /*
      ==============================================================================
      End of Calculate the total saving for the complete quantity, not only the saving for one unit.
      ==============================================================================
      */
      const strikeThroughHtml = `<span style="text-decoration: line-through; color: #9c9c9c !important; ">${formatPriceRespectingTaxDisplay(variantStorage, unitPrice)}</span>`;
      const savedBadgeHtml = `<div style="flex-basis: 100%;"> <span style="color: #fff; background: #7d9537; border-radius: 4px; padding: 2px 8px; font-size: 11px; font-weight: 500;">Sie sparen ${window.BSS_B2B.formatMoney(savedAmount)}</span> </div>`;
      return strikeThroughHtml + `<span class="bss-b2b-qb-price">${priceHtml}</span>` + savedBadgeHtml;
    };

    const setCartRowPricesLoading = (cartRowEl) => {
      cartRowEl.querySelectorAll(CART_PRICE_SELECTOR_ORIGIN).forEach(setPriceElementLoading);
      setPriceElementLoading(cartRowEl.querySelector(CART_PRICE_SELECTOR_FINAL_LINE));
    };

    const setCartTotalLoading = () => {
      document.querySelectorAll(CART_PRICE_SELECTOR_TOTAL).forEach(setPriceElementLoading);
    };

    const renderCartRowPricesSynced = (cartRowEl, overrideQuantity) => {
      const originPriceElements = cartRowEl.querySelectorAll(CART_PRICE_SELECTOR_ORIGIN);
      const finalLinePriceEl = cartRowEl.querySelector(CART_PRICE_SELECTOR_FINAL_LINE);
      if (!originPriceElements.length && !finalLinePriceEl) return;

      const pricing = computeCartLineQbPricing(cartRowEl, overrideQuantity);
      /*
      const originHtml = pricing ? buildOriginPriceHtml(pricing.variantStorage, pricing.unitPrice, pricing.discountedUnitPrice) : null;
      */
     /*
      ==============================================================================
      PUR HAIR PRO
      Calculate the total saving for the complete quantity,
      not only the saving for one unit.
      ==============================================================================
      */
     const originHtml = pricing
      ? buildOriginPriceHtml(
          pricing.variantStorage,
          pricing.unitPrice,
          pricing.discountedUnitPrice,
          pricing.quantity
        )
      : null;
      /*
      ==============================================================================
      End of Calculate the total saving for the complete quantity, not only the saving for one unit.
      ==============================================================================
      */

      const finalLinePrice = pricing ? Math.round(pricing.discountedUnitPrice * pricing.quantity * 100) / 100 : null;
      const finalHtml = pricing ? formatPriceRespectingTaxDisplay(pricing.variantStorage, finalLinePrice) : null;
      if (!originHtml || !finalHtml) {
        setCartRowPricesLoading(cartRowEl);
        return;
      }

      originPriceElements.forEach((originPriceElement) => {
        try {
          setPriceElementReady(originPriceElement, originHtml);
        } catch (originPriceErr) {
          console.log(
            `%c3e2e97c9-bc25-44c4-bf08-82f196d40ce6 renderCartRowPricesSynced origin: ${originPriceErr?.message || originPriceErr}`,
            "color: #B91C1C; font-weight: bold; font-size: 14px;"
          );
        }
      });
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setPriceElementReady(finalLinePriceEl, finalHtml);
        });
      });
    };

//     const renderCartTotalSynced = (rowWithOverride, overrideQuantity) => {
//       const cartTotalEls = document.querySelectorAll(CART_PRICE_SELECTOR_TOTAL);
//       if (!cartTotalEls.length) return;
//       if (!window.BSS_B2B?.storage?.variantStorage) {
//         cartTotalEls.forEach(setPriceElementLoading);
//         return;
//       }
//       const rows = [...document.querySelectorAll("[data-cart-item-key]")].filter((row) =>
//         row.querySelector(CART_QTY_INPUT_SELECTOR)
//       );
//       let sum = 0;
//       let anyMissing = false;
//       rows.forEach((row) => {
//         const overrideQty = rowWithOverride && row === rowWithOverride ? overrideQuantity : null;
//         const pricing = computeCartLineQbPricing(row, overrideQty);
//         if (!pricing) { anyMissing = true; return; }
//         sum += pricing.discountedUnitPrice * pricing.quantity;
//       });
//       if (anyMissing) {
//         cartTotalEls.forEach(setPriceElementLoading);
//         return;
//       }
//       // const totalHtml = window.BSS_B2B.formatMoney(Math.round(sum * 100) / 100);
//       const shopifyDiscount = Number(window.BSS_B2B?.shopData?.cart?.total_discount) || 0;
// const totalHtml = window.BSS_B2B.formatMoney(Math.max(Math.round(sum * 100) / 100 - shopifyDiscount, 0));
//       requestAnimationFrame(() => {
//         requestAnimationFrame(() => {
//           cartTotalEls.forEach((cartTotalEl) => setPriceElementReady(cartTotalEl, totalHtml));
//         });
//       });
//     };

const TOTAL_READY_ATTR = 'data-bss-total-ready';
let lastFinalTotal = null;

const cartSignature = (cart) => `${cart.token}:${cart.item_count}:${cart.total_price}:${cart.total_discount}`;

const isCartSettled = () => {
    const cart = window.BSS_B2B?.shopData?.cart;
    const storage = window.BSS_B2B?.storage?.cartStorage;
    if (!cart || !Array.isArray(cart.items) || !storage) return false;
    const cartKeys = new Set(cart.items.map((item) => item.key));
    if (storage.getAll().size !== cartKeys.size || [...cartKeys].some((key) => !storage.has(key))) return false;
    const domQuantities = new Map();
    document.querySelectorAll('[data-cart-item-key]').forEach((row) => {
        if (row.querySelector(CART_QTY_INPUT_SELECTOR)) {
            domQuantities.set(row.getAttribute('data-cart-item-key'), readCartRowQuantity(row, null));
        }
    });
    if (!domQuantities.size) return true;
    const domTotalQuantity = [...domQuantities.values()].reduce((sum, quantity) => sum + quantity, 0);
    return domTotalQuantity === cart.item_count;
};

const setTotalLoading = (element) => {
    element.removeAttribute(TOTAL_READY_ATTR);
    element.style.setProperty('visibility', 'hidden', 'important');
};

const setTotalReady = (element, html) => {
    setPriceElementReady(element, html);
    element.setAttribute(TOTAL_READY_ATTR, '1');
    element.style.setProperty('visibility', 'visible', 'important');
};

const renderFinalCartTotal = () => {
    const totalElements = document.querySelectorAll(CART_PRICE_SELECTOR_TOTAL);
    if (!totalElements.length) return;
    const cart = window.BSS_B2B?.shopData?.cart;
    if (!cart || !isCartSettled()) {
        totalElements.forEach(setTotalLoading);
        return;
    }
    const b2bTotal = cart.bss_b2b_total_price;
    const total =
        typeof b2bTotal === 'number' ? Math.max(b2bTotal - (Number(cart.total_discount) || 0), 0) : cart.total_price;
    const html = `<span>${window.BSS_B2B.formatMoney(total)}</span>`;
    lastFinalTotal = { signature: cartSignature(cart), html };
    totalElements.forEach((element) => setTotalReady(element, html));
    document.body.classList.remove('bss-price-hiding');
};

const renderCartTotalSynced = (rowWithOverride) => {
    const totalElements = document.querySelectorAll(CART_PRICE_SELECTOR_TOTAL);
    if (!totalElements.length) return;
    const cart = window.BSS_B2B?.shopData?.cart;
    const canReuseFinal =
        !rowWithOverride && cart && lastFinalTotal?.signature === cartSignature(cart) && isCartSettled();
    if (canReuseFinal) {
        totalElements.forEach((element) => setTotalReady(element, lastFinalTotal.html));
        return;
    }
    totalElements.forEach(setTotalLoading);
};

window.bssB2BHooks.actions['custom:cart/showSubtotalPrice'] = () => renderFinalCartTotal();



    const startCartRowPriceLoading = (cartRowEl) => {
      setCartRowPricesLoading(cartRowEl);
      setCartTotalLoading();
      return Date.now();
    };

    const revealCartRowPricesAfterMinDelay = (cartRowEl, overrideQuantity, loadingStartedAt) => {
      const remaining = MIN_PRICE_LOADING_DURATION_MS - (Date.now() - loadingStartedAt);
      setTimeout(() => {
        renderCartRowPricesSynced(cartRowEl, overrideQuantity);
        renderCartTotalSynced(cartRowEl, overrideQuantity);
      }, Math.max(0, remaining));
    };

    const triggerCartRowPriceRecalc = (cartRowEl, overrideQuantity) => {
      const loadingStartedAt = startCartRowPriceLoading(cartRowEl);
      revealCartRowPricesAfterMinDelay(cartRowEl, overrideQuantity, loadingStartedAt);
    };

    let isRefreshingCartLines = false;
    const refreshAllCartLines = () => {
      if (isRefreshingCartLines) return;
      isRefreshingCartLines = true;
      try {
        document.querySelectorAll("[data-cart-item-key]").forEach((row) => {
          renderCartRowPricesSynced(row);
        });
        renderCartTotalSynced();
      } finally {
        isRefreshingCartLines = false;
      }
    };

    document.addEventListener("input", (event) => {
      if (event.target.matches && event.target.matches(CART_QTY_INPUT_SELECTOR)) {
        const row = event.target.closest("[data-cart-item-key]");
        if (row) triggerCartRowPriceRecalc(row);
      }
    });

    document.addEventListener("click", (event) => {
      const qtyBtn = event.target.closest && event.target.closest('[aria-label="Plus"], [aria-label="Minus"]');
      if (!qtyBtn) return;
      const row = event.target.closest("[data-cart-item-key]");
      if (row) {
        const loadingStartedAt = startCartRowPriceLoading(row);
        setTimeout(() => {
          // Doc live quantity tai thoi diem chay (khong dung gia tri da chup truoc) -
          // chup truoc de bi lech thu tu khi bam qty lien tuc, gay hien thi gia cu.
          revealCartRowPricesAfterMinDelay(row, null, loadingStartedAt);
        }, 0);
      }
    
     /* 
     ==============================================================================
     Created by: Gino Cometti
      Date: 21.09.2026
     The code below is will be replaced by the following code under it.
     ==============================================================================

      CART_LINES_REFRESH_RETRY_DELAYS_MS.forEach((delay) => {
        setTimeout(refreshAllCartLines, delay);
      });
      ==============================================================================
      End of The code babove
      ==============================================================================
      */

     /*
      ==============================================================================
      PUR HAIR PRO – Targeted cart price retries

      Purpose:
      Refresh only the product whose quantity changed.
      Do not re-render every other product in the cart.
      ==============================================================================
      */
      if (row) {
        const changedCartItemKey =
          row.getAttribute("data-cart-item-key");

        CART_LINES_REFRESH_RETRY_DELAYS_MS.forEach(
          delay => {
            setTimeout(() => {
              const currentRow = document.querySelector(
                `[data-cart-item-key="${CSS.escape(
                  changedCartItemKey
                )}"]`
              );

              if (currentRow) {
                renderCartRowPricesSynced(currentRow);
              }

              /*
              The cart total must still be recalculated.
              */
              renderCartTotalSynced();
            }, delay);
          }
        );
      }
      /*
      ==============================================================================
      End of The code above
      ==============================================================================
      */
    });

    window.addEventListener("bss_b2b:loadedObserver", refreshAllCartLines);
    refreshAllCartLines();

    const PRICE_AREA_INSERTED_SELECTOR =
      '[bss-b2b-final-line-price], [bss-b2b-item-original-price], [bss-b2b-cart-total-price], .cart-item__price, .cart-item__final-line-price, .main-cart__total-price, .cart-drawer-item__price__wrapper';

    const findEnclosingCartRow = (priceAreaElement) => {
      const enclosingRow = priceAreaElement.closest('[data-cart-item-key]');
      if (!enclosingRow) return null;
      return enclosingRow.querySelector(CART_QTY_INPUT_SELECTOR) ? enclosingRow : null;
    };

    const cartRowInsertionObserver = new MutationObserver((mutations) => {
      const rowsToRerender = new Set();
      let shouldRerenderTotal = false;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          const priceAreaElements = node.matches(PRICE_AREA_INSERTED_SELECTOR)
            ? [node]
            : [...node.querySelectorAll(PRICE_AREA_INSERTED_SELECTOR)];
          priceAreaElements.forEach((priceAreaElement) => {
            if (priceAreaElement.matches('[bss-b2b-cart-total-price]')) {
              shouldRerenderTotal = true;
              return;
            }
            const enclosingRow = findEnclosingCartRow(priceAreaElement);
            if (enclosingRow) rowsToRerender.add(enclosingRow);
          });
        });
      });
      if (!rowsToRerender.size && !shouldRerenderTotal) return;
      // Khong disconnect() khi xu ly - mutation moi xay ra dung luc dang disconnect se bi mat vinh vien,
      // khong bao gio duoc observer bao lai (da verify bang test doc lap), gay hien tuong mat loading + gia cu.
      rowsToRerender.forEach((row) => renderCartRowPricesSynced(row));
      renderCartTotalSynced();
    });
    cartRowInsertionObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener("pagehide", () => cartRowInsertionObserver.disconnect(), { once: true });

    const bodyPriceHidingObserver = new MutationObserver(() => {
      if (document.body.classList.contains("bss-price-hiding")) {
        document.querySelectorAll("[data-cart-item-key]").forEach(setCartRowPricesLoading);
        setCartTotalLoading();
      } else {
        refreshAllCartLines();
      }
    });
    bodyPriceHidingObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    window.addEventListener("pagehide", () => bodyPriceHidingObserver.disconnect(), { once: true });

    const cartLinesRefreshInterval = setInterval(refreshAllCartLines, CART_LINES_REFRESH_FALLBACK_INTERVAL_MS);
    window.addEventListener("pagehide", () => clearInterval(cartLinesRefreshInterval), { once: true });
  } catch (err) {
    console.log(
      `%c3e2e97c9-bc25-44c4-bf08-82f196d40ce6: ${err?.message || err}`,
      "color: #B91C1C; font-weight: bold; font-size: 14px;"
    );
  }
})();
// end 3e2e97c9-bc25-44c4-bf08-82f196d40ce6
// start c1a0d2f4-2946-4da3-a3b7-c4aefa54c70f
(() => {
  try {
    const MAX_SYNC_WAIT_MS = 5000;
    const SYNC_CHECK_INTERVAL_MS = 200;
    const CART_OBSERVER_READY_POLL_MS = 200;
    const CART_OBSERVER_READY_TIMEOUT_MS = 15000;
    const SYNC_MESSAGE_ATTRIBUTE = "data-bss-checkout-sync-message";

    const SYNC_MESSAGE_BY_LOCALE = {
      en: "Syncing price, please wait\u2026",
      de: "Preis wird synchronisiert, bitte warten\u2026",
      fr: "Synchronisation du prix, veuillez patienter\u2026",
      es: "Sincronizando precio, espere por favor\u2026",
      it: "Sincronizzazione del prezzo, attendere\u2026",
      nl: "Prijs wordt gesynchroniseerd, even geduld\u2026",
    };
    const getCheckoutSyncMessage = () => {
      const localeCode = (window.Shopify?.locale || "en").toLowerCase().split("-")[0];
      return SYNC_MESSAGE_BY_LOCALE[localeCode] || SYNC_MESSAGE_BY_LOCALE.en;
    };

    // FIX B (correctness): trước đây chỉ so quantity, có thể pass trước khi
    // giá thật sự tính xong. Thay vì đoán tên field giá nội bộ (không đáng
    // tin cậy - có nhiều field cùng tên gần giống nhau), dùng đúng tín hiệu
    // app ĐÃ tự phát ra sẵn cho việc này: class "bss-price-hiding" trên
    // <body> - được app tự thêm lúc bắt đầu tính lại giá (xem listener click/
    // change đầu file) và tự gỡ qua action "custom:cart/showSubtotalPrice"
    // khi tính xong. Class còn tồn tại = giá đang/chưa tính xong.
    const isCartPriceCalculationFinished = () =>
      !document.body.classList.contains("bss-price-hiding");

    const isCartStorageMatchingRealCart = (realCart) => {
      const cartStorage = window.BSS_B2B.storage.cartStorage;
      const quantitiesMatch = realCart.items.every((realItem) => {
        const storedItem = cartStorage.get(realItem.key);
        return storedItem && storedItem.quantity === realItem.quantity;
      });
      return quantitiesMatch && isCartPriceCalculationFinished();
    };

    const waitUntilCartStorageMatches = async (targetCart) => {
      const startTime = Date.now();
      while (Date.now() - startTime < MAX_SYNC_WAIT_MS) {
        if (isCartStorageMatchingRealCart(targetCart)) return;
        await new Promise((resolve) => setTimeout(resolve, SYNC_CHECK_INTERVAL_MS));
      }
    };

    const showCheckoutSyncMessage = () => {
      if (document.querySelector(`[${SYNC_MESSAGE_ATTRIBUTE}]`)) return;
      const syncMessageElement = document.createElement("div");
      syncMessageElement.setAttribute(SYNC_MESSAGE_ATTRIBUTE, "");
      syncMessageElement.textContent = getCheckoutSyncMessage();
      syncMessageElement.style.cssText =
        "position:fixed;bottom:16px;right:16px;background:#111;color:#fff;padding:10px 16px;border-radius:6px;font-size:13px;z-index:99999;";
      document.body.appendChild(syncMessageElement);
    };

    const hideCheckoutSyncMessage = () => {
      const syncMessageElement = document.querySelector(`[${SYNC_MESSAGE_ATTRIBUTE}]`);
      if (syncMessageElement) syncMessageElement.remove();
    };

    const ensureCartPriceSyncedBeforeCheckout = async (_context, next) => {
      const realCart = await window.BSS_B2B.utils.AjaxCartApi.getCart();
      if (!isCartStorageMatchingRealCart(realCart)) {
        showCheckoutSyncMessage();
        document.dispatchEvent(
          new CustomEvent("bss_b2b:CustomCartUpdate", { detail: { cart: realCart } })
        );
        await waitUntilCartStorageMatches(realCart);
        hideCheckoutSyncMessage();
      }
      next();
    };

    const registerCartCheckoutGuard = () => {
      const cartObserver = window.BSS_B2B?.observer?.cartObserver;
      if (!cartObserver) return false;
      cartObserver.use("CartCheckout", ensureCartPriceSyncedBeforeCheckout);
      return true;
    };

    if (!registerCartCheckoutGuard()) {
      const readyPollIntervalId = setInterval(() => {
        if (registerCartCheckoutGuard()) clearInterval(readyPollIntervalId);
      }, CART_OBSERVER_READY_POLL_MS);
      setTimeout(() => clearInterval(readyPollIntervalId), CART_OBSERVER_READY_TIMEOUT_MS);
    }
  } catch (err) {
    console.log(
      `%cc1a0d2f4-2946-4da3-a3b7-c4aefa54c70f: ${err?.message || err}`,
      "color: #B91C1C; font-weight: bold; font-size: 14px;"
    );
  }
})();
// end c1a0d2f4-2946-4da3-a3b7-c4aefa54c70f

// start d1ee1125-8892-455a-b240-8533aafa06f3
(() => {
  try {
    const LOADING_STYLE_ELEMENT_ID = "bss-b2b-price-loading-indicator-style";
    if (document.getElementById(LOADING_STYLE_ELEMENT_ID)) return;

    const HIDDEN_PRICE_SELECTORS = [
      "[bss-b2b-variant-price]",
      "[bss-b2b-product-price]",
      "[bss-b2b-cart-item-key][bss-b2b-item-original-price]",
      "[bss-b2b-cart-item-key][bss-b2b-final-line-price]",
      "[bss-b2b-cart-item-key] [bss-b2b-item-original-price]",
      "[bss-b2b-cart-item-key] [bss-b2b-final-line-price]",
      "[bss-b2b-cart-total-price]",
    ];

    const anchorRuleCss = HIDDEN_PRICE_SELECTORS
      .map((selector) => selector + " { position: relative; min-width: 1.4em; min-height: 1em; }")
      .join("\n");

    const spinnerRuleCss =
      HIDDEN_PRICE_SELECTORS
        .map((selector) => selector + ':not([style*="visible"])::after')
        .join(",\n") +
      " { " +
      "content: '';" +
      "visibility: visible !important;" +
      "position: absolute;" +
      "top: 50%;" +
      "left: 0;" +
      "width: 13px;" +
      "height: 13px;" +
      "margin-top: -7px;" +
      "border-radius: 50%;" +
      "border: 2px solid rgba(120, 120, 120, 0.25);" +
      "border-top-color: rgba(80, 80, 80, 0.65);" +
      "animation: bssB2BPriceLoadingSpin 0.6s linear infinite;" +
      " } " +
      "@keyframes bssB2BPriceLoadingSpin { to { transform: rotate(360deg); } }";

    const styleElement = document.createElement("style");
    styleElement.id = LOADING_STYLE_ELEMENT_ID;
    styleElement.textContent = anchorRuleCss + "\n" + spinnerRuleCss;
    document.head.appendChild(styleElement);
  } catch (err) {
    console.log(
      "%cd1ee1125-8892-455a-b240-8533aafa06f3: " + (err?.message || err),
      "color: #B91C1C; font-weight: bold; font-size: 14px;"
    );
  }
})();
// end d1ee1125-8892-455a-b240-8533aafa06f3